// 111 §5b — THE MODAL FOOTER EVERY Stage / Task / Event add+edit modal ends
// with. One component so the three modals cannot drift.
//
// 112 §4 — THE FOOTER TOOK THE APP'S CONVENTION (the TimeEntryModal shape —
// variant saves above, the quiet "Close without Saving" text link, the
// full-width primary last). The 111 2-column grid went with it.
//
//   **112 §4 IS WITHDRAWN BY BRIEF 138 §1, WITH THE HIERARCHY IT DESCRIBED.**
//   "The full-width primary last" cannot survive there being no primary. What
//   112 gave this file and 138 keeps is the SHAPE — stacked full-width rows,
//   a quiet three-across line — not the ranking.
//
// 112 §7 (ADDENDUM) — "Link…" joins that line beside Unlink all: the Links
// manager, the path to link two items AFTER both exist (the chains were the
// only door). Disabled on an unsaved form.
//
// BRIEF 113 §3 — AND NOW IT ACTUALLY COPIES THE MODEL IT NAMED (RULED).
// 112's middle line put Link… and Unlink all on the quiet line as SMALL
// borderless scraps crammed left of the close link; beside the real
// TimeEntryModal the verdict was "nowhere near". Top to bottom, 113 to 137:
//
//     [ Save + create Stage ][ Save + create Event ][ Save + create Task ]
//     [ Link…       ][ Close without saving ][       Unlink all ]
//     [                  Save & EXIT                            ]
//
//   (137 §3 REWROTE THE FIRST AND THIRD OF THOSE LINES — two spawns, not
//   three, and a primary that names what it saves. 138 §1 THEN REWROTE THE
//   ARRANGEMENT ITSELF; see its block below for what stands today.)
//
//   · THE MIDDLE LINE IS THREE EQUAL THIRDS, all three REAL buttons with
//     borders — the same grid the spawn row uses. The equality is the point,
//     which is why "Close without saving" stops being the `.modal-cancel`
//     text link here: a link between two buttons cannot be one of three
//     equals. It keeps the neutral family (`.btn-ghost`: --br border, --ts
//     ink), the two link actions keep the purple one, and every behaviour is
//     unchanged — onCancel is still onCancel, Unlink all still disables when
//     there is nothing to unlink and still confirms via the house Undo toast,
//     Link… still disables only on an UNSAVED form.
//   · THE PRIMARY WAS "Save & EXIT" until 137 §3 gave it the kind's own key
//     (`modal.save_stage` / `modal.save_task` / the reused
//     `modal.ag.save_event`), and 138 §1 then stopped it being a primary at
//     all. `modal.save_exit` is no longer read by this
//     file; its rows stay in the seed. What follows is 113's reasoning for
//     minting it, kept because it is still why the key EXISTS —
//     112's sentence saying the timelog's
//     wording "belongs to that modal, not to the convention" is WITHDRAWN by
//     the ruling. The key is NEW AND SHARED (`modal.save_exit`): censused,
//     the only existing one is `modal.te.save_exit`, modal-SCOPED by its own
//     namespace and carrying that modal's ✓ — so the shared key is minted and
//     the te rows stay untouched, exactly as `modal.close_without_saving` was
//     minted beside `modal.te.close_without_saving` in 112 §4.
//   · "Close without saving" REPLACES Cancel (112 §4, unchanged): same
//     behaviour as Cancel, the host's onCancel.
//
// Purple is the LINK colour and it is the `--pp` token, never a literal.
// `spawnDisabled` covers the matter-less form: the store is matter-scoped, so
// an item bound to no case/cc has nowhere to record a link — the chain
// buttons grey out rather than half-working (enumerated in the §5b design).
//
// BRIEF 137 §2 [RULED, Laurent, 2026-08-25] — THE MODAL OWNS THE COLOUR,
// EVERYWHERE, NOT ONLY AFTER A DROP. This footer used to know nothing about
// how it was opened, so a Task modal's spawn row was violet and its primary
// was solid `--ac` — the chooser's *Event* colour, one dialog later. A footer
// that changes livery according to the door it was opened through is want (i)
// itself, "always a guess about what will appear". One modal, one colour.
//
// `kind` is that colour's only input, and `KIND` below is the one map, held
// here exactly as the chooser holds `TONE` and `DOC_TONE`
// (`EmailDropChooser.tsx:150-154`, `:196-201`). The chooser's palette is the
// SOURCE for the two kinds that appear in it and is not touched.
//
//     stage  →  --pp   the violet it already had. It appears in neither
//                      chooser, so there is nothing to match: this is the
//                      no-change answer, not a choice.
//     task   →  --gn   the chooser's Tâche
//     event  →  --ac   the chooser's Événement
//
// THE MIDDLE ROW IS DELIBERATELY NOT RETONED. Violet there is the LINK colour
// and this file's own header rules it (:41). Laurent's sentence is about the
// save family, and `Lier…` / `Tout délier` are not in it.
//
// ── BRIEF 138 §1 [RULED, Laurent, 2026-08-25] — THREE EQUAL SAVES. ──────────
// ── NO PRIMARY, AND THEREFORE NO SAVE BAR. ─────────────────────────────────
//
// Laurent, on 137 §2's build: *"there should be no save bar, the 3 buttons ARE
// the save bars, it is for such reason that I raised and wanted to remedy the
// confusion, you silently reintroduced it."*
//
// The confusion he reported was a footer holding several DIFFERENT-LOOKING ways
// to save one thing — violet outlined spawns, a solid blue bar, and on the Event
// modal a second solid blue bar. 137 §2 answered it with a better-behaved
// primary, which is the same error one step smaller. **The remedy is that there
// is no primary at all**: every save here is built from ONE object and they
// differ only in their labels.
//
//     [ Save Task                                   ]
//     [ Save Task & create Event                    ]
//     [ Save Task & create Stage                    ]
//     [ Lier… ][ Fermer sans enregistrer ][ Tout délier ]
//
// THE ORDER IS LAURENT'S, twice stated, and it is why 112 §4's "primary last"
// is withdrawn above rather than merely overridden here.
//
// `.modal-save` LEAVES THIS FOOTER. It is the app's solid-blue save class and
// every other modal in the tree keeps it; here it is precisely what made one
// save look unlike its two neighbours. **The geometry is taken, the class is
// not** — `save()` below restates `.modal-save`'s box (App.css:1119-1134:
// 100% wide, 12/24, `--fs-14`, weight 600, `--rad-8`, centred inline-flex) and
// takes its colour from the 15% wash instead of the solid `--ac`.
//
// **`--c-fff` DOES NOT APPEAR IN THIS FOOTER**, and no literal does: the whole
// colour is `color-mix` over `var(--<tone>)`, so a firm that repaints its theme
// repaints these.
//
// MEASURED (138 §1e), ink-on-its-own-ground, WCAG 2.1, over `.modal`'s
// background `var(--bs)` (App.css:992-993), across the 14 `Theme` rows on
// staging — which hold four distinct palettes:
//
//                        Dark #141820   Light #ffffff   Blue #1B2A4A
//     task   --gn            6.92            1.73           5.45
//     event  --ac            3.96            3.14           2.40
//     stage  --pp            5.16            2.38           4.09
//
// The dark palettes are comfortable and the LIGHT ONE IS NOT — green there is
// 1.73:1, BELOW the 1.92:1 that stopped 137 §2's solid ground. That is not a
// defect this § introduces: it is the recipe `EmailDropChooser` has shipped on
// its own four buttons since 125, at the same numbers, and repointing it is a
// theme question rather than a footer one. Reported rather than acted on,
// because §1 rules the recipe and asks for the number.
import { useTranslation } from "../i18n";
import { FS } from "../lib/tokens";

export type ChainKind = "stage" | "task" | "event";

/* ONE MAP, ONE FILE — the tone (§2), the primary's key and the spawns (§3).
 *
 * BRIEF 137 §3 — THE BUTTONS SAY WHAT THEY SAVE, AND A MODAL NO LONGER SPAWNS
 * ITS OWN KIND. `links.save_create_stage/_event/_task` were host-blind: inside
 * the Task modal, "Enregistrer et créer un événement" did not say what it was
 * saving, and the primary (`modal.save_exit`, "Enregistrer & QUITTER") named
 * nothing at all. The footer also rendered ALL THREE spawns in every host, so
 * the Event modal carried a "Save and create Event".
 *
 * Laurent named the buttons twice, symmetrically, and both lists have THREE —
 * each omitting the modal's own kind. `spawns` below is that omission, and the
 * ORDER is his:
 *
 *     Event modal:  Save the event · Save Event & create Task  · … Stage
 *     Task  modal:  Save Task      · Save Task  & create Event · … Stage
 *     Stage modal:  Save Stage     · Save Stage & create Event · … Task
 *
 * `onSpawn` keeps its `ChainKind` signature; only what is RENDERED changes.
 * This removes one road — Event → Event (a hearing chained to its follow-up),
 * and its twins on Task and Stage. It is here because the self-spawn is the
 * one button both of Laurent's lists omit and because "Save Event & create
 * Event" is not a label anybody writes. IF HE WANTS IT BACK IT IS ONE LINE:
 * give the kind its own row in `spawns`.
 *
 * `modal.ag.save_event` is REUSED for the event save rather than twinned —
 * it already reads "Save the event" / "Enregistrer l'événement" / "De
 * gebeurtenis opslaan". `AgendaEventModal.tsx` overrides it through `saveLabel`
 * anyway, with `modal.ag.save_changes` on an edit (`eventSaveWords`, in
 * `lib/meetingMode.ts`); that derivation survives 137 §4's narrowing and this
 * entry is what the footer would say without it.
 */
const KIND: Record<
  ChainKind,
  {
    tone: string;
    saveKey: string;
    saveFallback: string;
    spawns: { to: ChainKind; key: string; fallback: string }[];
  }
> = {
  stage: {
    tone: "--pp",
    saveKey: "modal.save_stage",
    saveFallback: "Save Stage",
    spawns: [
      { to: "event", key: "links.stage.create_event", fallback: "Save Stage & create Event" },
      { to: "task", key: "links.stage.create_task", fallback: "Save Stage & create Task" },
    ],
  },
  task: {
    tone: "--gn",
    saveKey: "modal.save_task",
    saveFallback: "Save Task",
    spawns: [
      { to: "event", key: "links.task.create_event", fallback: "Save Task & create Event" },
      { to: "stage", key: "links.task.create_stage", fallback: "Save Task & create Stage" },
    ],
  },
  event: {
    tone: "--ac",
    saveKey: "modal.ag.save_event",
    saveFallback: "Save the event",
    spawns: [
      { to: "task", key: "links.event.create_task", fallback: "Save Event & create Task" },
      { to: "stage", key: "links.event.create_stage", fallback: "Save Event & create Stage" },
    ],
  },
};

export default function LinkChainFooter({
  kind,
  onSave,
  saveLabel,
  onSpawn,
  spawnDisabled,
  unlinkDisabled,
  onUnlinkAll,
  linkDisabled,
  onLinkManager,
  onCancel,
}: {
  /** 137 §2 — which modal this footer is ending. The tone is derived from it,
   *  and nothing else about the footer's livery is a prop. */
  kind: ChainKind;
  onSave: () => void;
  /** 117 §6a — overrides the primary's label; absent, the primary takes its
   *  own kind's key from `KIND` (137 §3). */
  saveLabel?: string;
  /* BRIEF 119 §1c/§2's SECOND PRIMARY IS WITHDRAWN (137 §4d). It was
     "Save & invite" beside the plain save, and only `AgendaEventModal` ever
     passed it — the Stage and Task modals never had it. §4 replaces the choice
     with a consequence: whether mail leaves follows from who is on the event,
     so there is nothing for a second button to decide. */
  onSpawn: (next: ChainKind) => void;
  spawnDisabled?: boolean;
  unlinkDisabled?: boolean;
  onUnlinkAll: () => void;
  /* 112 §7 — "Link…" opens the Links manager; disabled on an UNSAVED form
     exactly like Unlink all (no id, nothing to link) — but NOT keyed on
     having links: a saved item with zero links is precisely the one the
     manager exists for. */
  linkDisabled?: boolean;
  onLinkManager: () => void;
  onCancel: () => void;
}) {
  const { t } = useTranslation();
  /* 113 §3 — the middle line's three equals. One base, so a difference between
     them can only be the two things that ARE different: the border/ink family,
     and whether the action can be disabled. `justifyContent` is set because
     `.btn` is an inline-flex with no justification of its own, and three
     left-aligned labels in three equal cells do not read as a row. */
  const rowBtn = (disabled?: boolean) => ({
    opacity: disabled ? 0.35 : 1,
    cursor: disabled ? "default" : "pointer",
    fontSize: FS.s11,
    padding: "6px 8px",
    borderRadius: "var(--rad-8)",
    fontFamily: "inherit",
    justifyContent: "center",
    background: "none",
  });
  /* ── 138 §1(a) — THE ONE DEFINITION EVERY SAVE IN THIS FOOTER IS BUILT FROM ──
     No variant, no emphasis, no `primary` argument. The only thing a caller
     may vary is whether the action is currently available, and that is the
     footer's own disabled convention (`rowBtn` above uses the same 0.35),
     NOT a second look.

     COLOUR — 137 §2's wash, the chooser's recipe verbatim
     (`EmailDropChooser.tsx:244-246`): a 15% ground, the token as INK, a 30%
     border. This tree's house pattern for a wash from a token (App.css:1157,
     ScheduleGrid.tsx:325); it satisfies §4.9 for the same reason the chooser's
     four buttons do, since no literal enters and the whole colour is
     `color-mix` over a variable.

     GEOMETRY — `.modal-save`'s box (App.css:1119-1134), restated here because
     138 §1(b) takes the geometry and NOT the class. `.modal-save` is the app's
     solid-blue save and every other modal keeps it; it is what made one save
     in this footer look unlike its neighbours, so it leaves. The two spawns
     grow from FS.s11/6-8 to this, which is 138 §1(f)'s "the footer grows by
     roughly one button's height" and is the shape asked for. */
  const save = (disabled?: boolean) => {
    const v = KIND[kind].tone;
    return {
      width: "100%",
      padding: "12px 24px",
      fontSize: FS.s14,
      fontWeight: 600,
      background: `color-mix(in srgb, var(${v}) 15%, transparent)`,
      color: `var(${v})`,
      border: `1px solid color-mix(in srgb, var(${v}) 30%, transparent)`,
      borderRadius: "var(--rad-8)",
      fontFamily: "inherit",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 6,
      opacity: disabled ? 0.35 : 1,
      cursor: disabled ? "default" : "pointer",
    };
  };
  return (
    <div className="modal-footer">
      {/* 138 §1(c) — LAURENT'S ORDER: the plain save, then the two spawns, each
          on its own full-width row. `.modal-footer` is a stretch column
          (App.css:1098-1106), so the rows are siblings and no grid is needed —
          a grid here would be a container implying a relationship between the
          things inside it, and the whole § is that there is none. */}
      <button type="button" className="btn" style={save()} onClick={onSave}>
        {saveLabel || t(KIND[kind].saveKey, { fallback: KIND[kind].saveFallback })}
      </button>
      {/* 137 §3 — the TWO spawns that are not this modal's own kind. */}
      {KIND[kind].spawns.map((s) => (
        <button
          key={s.to}
          type="button"
          className="btn"
          style={save(spawnDisabled)}
          disabled={spawnDisabled}
          onClick={() => onSpawn(s.to)}
        >
          {t(s.key, { fallback: s.fallback })}
        </button>
      ))}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr",
          gap: 6,
        }}
      >
        <button
          type="button"
          className="btn"
          style={{ ...rowBtn(linkDisabled), border: "1px solid var(--pp)", color: "var(--pp)" }}
          disabled={linkDisabled}
          onClick={onLinkManager}
        >
          {t("links.link_existing", { fallback: "Link…" })}
        </button>
        {/* The neutral third: `.btn-ghost` is the app's own bordered-neutral
            button (--br border, --ts ink), so the row's odd one out is odd in
            the house way and not in a new one. */}
        <button
          type="button"
          className="btn btn-ghost"
          style={rowBtn()}
          onClick={onCancel}
        >
          {t("modal.close_without_saving", {
            fallback: "Close without Saving",
          })}
        </button>
        <button
          type="button"
          className="btn"
          style={{ ...rowBtn(unlinkDisabled), border: "1px solid var(--pp)", color: "var(--pp)" }}
          disabled={unlinkDisabled}
          onClick={onUnlinkAll}
        >
          {t("links.unlink_all", { fallback: "Unlink all" })}
        </button>
      </div>
      {/* BRIEF 117 §6a — THE BUTTON TELLS THE TRUTH. `saveLabel` lets the one
          host that knows say what its save will do (`AgendaEventModal`, through
          `meetingMode.ts`'s `saveKey`); every other footer takes its own kind's
          key from `KIND`. That prop survives 138 §1 unchanged — a LABEL is what
          distinguishes these three buttons, and the only thing that may.

          137 §2's SOLID PRIMARY AND ITS STOP ARE BOTH GONE. The stop reported
          `--gn` at 1.92:1 against `--c-fff` and asked Laurent to rule the ink;
          he ruled the button away instead. The measurement that replaced it —
          the wash, on all four palettes — is in this file's header block, and
          it is worse in one place than the number that stopped 137. Kept there
          rather than here because it is now a fact about `save()`, which is
          declared once and drawn three times. */}
    </div>
  );
}
